import { useEffect, useState } from "react";
import { getprofileapi, updateUser } from "../../network/api/user.js";
import { useTranslation } from "react-i18next";
import Title from "./Title.jsx";
const Name_REGEX = /^[A-Za-z\u0600-\u06FF\s]*$/; //reg for name which contain space and charachters only
const Phone_REGEX = /^\d*$/; //reg for name which contain numbers

function User({ setgetUserName }) {
  const [fristName, setfristName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [getCurrentUser, setCurrentUser] = useState({});
  const [Error, setError] = useState("");
  const [edit, setEdit] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    getprofileapi().then((result) => {
      setfristName(result?.response?.first_name);
      setLastName(result?.response?.last_name);
      setEmail(result?.response?.email);
      setPhone(result?.response?.telephone);
      setCurrentUser(result?.response);
      setgetUserName(result?.response?.first_name+result?.response?.last_name)
    });
  }, []);

  const handleFristName = (e) => {
    if (Name_REGEX.test(e)) setfristName(e);
  };
  const handleLastName = (e) => {
    if (Name_REGEX.test(e)) setLastName(e);
  };
  const handlePhone = (e) => {
    if (Phone_REGEX.test(e)) setPhone(e);
  };
  const submitHandler = async (e) => {
    e.preventDefault();
    if (
      getCurrentUser?.first_name !== fristName ||
      getCurrentUser?.last_name !== lastName ||
      getCurrentUser?.telephone !== phone
    ) {
      await updateUser({
        firstName: fristName,
        lastName: lastName,
        phoneNumber: phone,
      });
      window.location.reload();
    } else {
      setError("can't update data you must change the fields");
      setTimeout(() => {
        setError("");
      }, 2000);
    }
  };

  return (
    <div className=" d-flex flex-column w-100 ">
      <Title title={fristName+lastName} text="أهلا بك فى حسابك" />
      <div className='account-item p-3 flex-grow-1' >
        <div className="d-flex justify-content-between ">
          <div className='head d-flex gap-1 align-items-center'>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.9974 9.33317C9.83834 9.33317 11.3307 7.84079 11.3307 5.99984C11.3307 4.15889 9.83834 2.6665 7.9974 2.6665C6.15645 2.6665 4.66406 4.15889 4.66406 5.99984C4.66406 7.84079 6.15645 9.33317 7.9974 9.33317ZM7.9974 9.33317C5.05188 9.33317 2.66406 11.124 2.66406 13.3332M7.9974 9.33317C10.9429 9.33317 13.3307 11.124 13.3307 13.3332" stroke="#C99700" stroke-width="1.5" stroke-linecap="round" />
            </svg>
            <h2>{t('Account')}</h2>
          </div>
          <button onClick={() => setEdit(true)}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8445 5.45593C14.6256 4.67488 14.6256 3.40855 13.8445 2.6275L13.3731 2.1561C12.5921 1.37505 11.3258 1.37505 10.5447 2.1561L2.95356 9.74726C2.67777 10.023 2.48864 10.3734 2.40944 10.7553L1.87367 13.3388C1.77624 13.8086 2.19203 14.2244 2.66182 14.127L5.2453 13.5912C5.6272 13.512 5.97761 13.3229 6.25339 13.0471L13.8445 5.45593ZM12.9017 3.57031L12.4303 3.09891C12.17 2.83856 11.7479 2.83856 11.4875 3.09891L10.7804 3.80604L12.1946 5.22025L12.9017 4.51312C13.1621 4.25277 13.1621 3.83066 12.9017 3.57031ZM11.2518 6.16306L9.83758 4.74885L3.89637 10.6901C3.80444 10.782 3.74139 10.8988 3.71499 11.0261L3.38544 12.6152L4.97455 12.2856C5.10185 12.2592 5.21866 12.1962 5.31059 12.1043L11.2518 6.16306Z" fill="white" />
            </svg>
            <span>تعديل</span>
          </button>
        </div>
        <div className="user-account flex-grow-1">
          <ul className="me-4">
            <li className=" fw-bold">{t('Account')}</li>
          </ul>
          {Error && (
            <div className="alert alert-danger" role="alert">
              {Error}
            </div>
          )}
          {edit ?
            <form action="" method="" onSubmit={submitHandler}>
              <div className="row">
                <div className="col-12 col-md-11 col-lg-6 align-self-start d-flex flex-column">
                  <label>{t("FirstName")}</label>
                  <input
                    type="text"
                    name="fristName"
                    value={fristName}
                    onChange={(e) => { handleFristName(e.target.value); }}
                  />
                </div>
                <div className="col-12 col-md-11 col-lg-6 align-self-start d-flex flex-column">
                  <label>{t("LastName")} </label>
                  <input
                    type="text"
                    name="lastName"
                    value={lastName}
                    onChange={(e) => { handleLastName(e.target.value); }}
                  />
                </div>
                <div className="col-12 col-md-11 col-lg-6 align-self-start d-flex flex-column">
                  <label>{t("Email")}</label>
                  <input
                    disabled
                    type="text"
                    name="email"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); }}
                  />
                </div>
                <div className="col-12 col-md-11 col-lg-6 align-self-start d-flex flex-column">
                  <label>{t("PhoneNumber")}</label>
                  <input
                    type="text"
                    name="phone"
                    value={phone}
                    onChange={(e) => { handlePhone(e.target.value); }}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-center justify-content-lg-start">
                <input type="submit" value={`${t("Update")}`} className="submit" />
              </div>
            </form>
            :
            <div className="user-show">
              <p>{t("FirstName")}</p>
              <h6>{fristName} {lastName}</h6>
              <p>{t("Email")}</p>
              <h6>{email}</h6>
              <p>{t("PhoneNumber")}</p>
              <h6>{phone}</h6>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
export default User;
